import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/* eslint-disable jsx-a11y/no-static-element-interactions */
import "./scss/index.scss";
import * as React from "react";
import ReactSVG from "react-svg";
import { LoginForm, Offline, OfflinePlaceholder, Online, Overlay, OverlayTheme, OverlayType } from "../..";
import signIn from "../../../images/sign-in.svg";
import closeImg from "../../../images/x.svg";
import ForgottenPassword from "./ForgottenPassword";
import RegisterForm from "./RegisterForm";
import { withIntlsHOC } from "../../Locale/Locale";
import { commonMessages } from "../../../intl";

var Login =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Login, _React$Component);

  function Login() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, Login);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Login)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      active: _this.props.active
    }, _this.changeActiveTab = function (active) {
      _this.setState({
        active: active
      });
    }, _temp));
  }

  _createClass(Login, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          overlay = _this$props.overlay,
          intl = _this$props.intl;
      var show = overlay.show,
          hide = overlay.hide;
      return React.createElement(Overlay, {
        context: overlay
      }, React.createElement("div", {
        className: "login"
      }, React.createElement(Online, null, React.createElement("div", {
        className: "overlay__header"
      }, React.createElement(ReactSVG, {
        path: closeImg,
        onClick: hide,
        className: "overlay__header__close-icon"
      })), React.createElement("div", {
        className: "overlay__body"
      }, React.createElement(ReactSVG, {
        path: signIn,
        className: "overlay__body__login-icon"
      })), React.createElement("div", {
        className: "login__tabs"
      }, React.createElement("span", {
        onClick: function onClick() {
          return _this2.changeActiveTab("login");
        },
        className: this.state.active === "login" ? "active-tab" : ""
      }, intl.formatMessage(commonMessages.signIn)), React.createElement("span", {
        onClick: function onClick() {
          return _this2.changeActiveTab("register");
        },
        className: this.state.active === "register" ? "active-tab" : ""
      }, intl.formatMessage(commonMessages.register))), React.createElement("div", {
        className: "login__content"
      }, this.state.active === "login" ? React.createElement(React.Fragment, null, React.createElement(LoginForm, {
        hide: hide
      }), React.createElement(ForgottenPassword, {
        onClick: function onClick() {
          show(OverlayType.password, OverlayTheme.modal);
        }
      })) : React.createElement(RegisterForm, {
        hide: hide,
        show: show
      }))), React.createElement(Offline, null, React.createElement(OfflinePlaceholder, null))));
    }
  }]);

  return Login;
}(React.Component);

Login.defaultProps = {
  active: "login"
};
export default withIntlsHOC(Login);